const env = process.env.NODE_ENV;

export const isDev = env === 'development';
export const isBetaEnv =
  process.env.BETA_ENV === 'true' ||
  process.env.NEXT_PUBLIC_BETA_ENV === 'true';

export const createSkeletons = (count: number, offset: number) =>
  Array.from({ length: count }, (_, i) => ({
    loading: true,
    id: `skeleton-${offset}-${i}`,
  }));

export const omitNullKeys = (obj: TODO) => {
  const result =
    obj !== null && typeof obj === 'object'
      ? Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(obj).filter(([_, v]) => v != null && v !== '')
      )
      : null;
  return result && Object.keys(result).length > 0 ? result : null;
};

export const capitalizeAllWords = (str: string, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(
    /(?:^|\s|["'([{])+\S/g,
    (match: string) => match.toUpperCase()
  );

export function range(start: number, end: number, step = 1) {
  if (step === 0) throw new Error('Step cannot be zero');
  if (start > end && step > 0) step = -step; // Adjust step for descending order
  return Array.from(
    { length: Math.ceil(Math.abs((end - start) / step)) },
    (_, i) => start + i * step
  );
};
